export const NINTENDO_HARDWARE = [
{
    id: "switch-2",
    name: "Nintendo Switch 2",
    brand: "Nintendo",
    type: "console",
    category: "Nintendo",
    variants: [
      {
        id: "switch-2-standard",
        name: "Nintendo Switch 2",
        versions: [
          {
            id: "switch-2-256",
            name: "Nintendo Switch 2",
            storage: "256 Go",
            disc: false,
            image: "/images/consoles/switch-2.png",
          },
        ],
      },
    ],
  },

{
    id: "switch",
    name: "Nintendo Switch",
    brand: "Nintendo",
    type: "console",
    category: "Nintendo",
    variants: [
      {
        id: "switch-classic",
        name: "Nintendo Switch",
        versions: [
          {
            id: "switch-v1",
            name: "Nintendo Switch V1",
            storage: "32 Go",
            disc: false,
            image: "/images/consoles/switch-v1.png",
          },
          {
            id: "switch-v2",
            name: "Nintendo Switch V2",
            storage: "32 Go",
            disc: false,
            image: "/images/consoles/switch-v1.png",
          },
        ],
      },
      {
        id: "switch-oled",
        name: "Nintendo Switch OLED",
        versions: [
          {
            id: "switch-oled-64",
            name: "Nintendo Switch OLED",
            storage: "64 Go",
            disc: false,
            image: "/images/consoles/switch-oled.png",
          },
        ],
      },
      {
        id: "switch-lite",
        name: "Nintendo Switch Lite",
        versions: [
          {
            id: "switch-lite-32",
            name: "Nintendo Switch Lite",
            storage: "32 Go",
            disc: false,
            image: "/images/consoles/switch-lite.png",
          },
        ],
      },
    ],
  },

  {
    id: "wii",
    name: "Nintendo Wii",
    brand: "Nintendo",
    type: "console",
    category: "Nintendo",
    variants: [
      {
        id: "wii-standard",
        name: "Wii",
        versions: [
          {
            id: "wii-standard",
            name: "Nintendo Wii",
            storage: "512 Mo",
            disc: true,
            image: "/images/consoles/wii.png",
          },
        ],
      },
      {
        id: "wii-family-edition",
        name: "Wii Family Edition",
        versions: [
          {
            id: "wii-family-edition",
            name: "Wii Family Edition",
            storage: "512 Mo",
            disc: true,
            image: "/images/consoles/wii-family.png",
          },
        ],
      },
      {
        id: "wii-mini",
        name: "Wii Mini",
        versions: [
          {
            id: "wii-mini",
            name: "Wii Mini",
            storage: "512 Mo",
            disc: true,
            image: "/images/consoles/wii-mini.png",
          },
        ],
      },
    ],
  },

  {
    id: "ds-3ds",
    name: "Nintendo DS / 3DS",
    brand: "Nintendo",
    type: "console",
    category: "Nintendo",
    variants: [
      {
        id: "ds",
        name: "Nintendo DS",
        versions: [
          {
            id: "ds-fat",
            name: "Nintendo DS",
            storage: "",
            disc: false,
            image: "/images/consoles/ds.png",
          },
          {
            id: "ds-lite",
            name: "Nintendo DS Lite",
            storage: "",
            disc: false,
            image: "/images/consoles/ds-lite.png",
          },
          {
            id: "dsi",
            name: "Nintendo DSi",
            storage: "256 Mo",
            disc: false,
            image: "/images/consoles/dsi.png",
          },
          {
            id: "dsi-xl",
            name: "Nintendo DSi XL",
            storage: "256 Mo",
            disc: false,
            image: "/images/consoles/dsi-xl.png",
          },
        ],
      },
      {
        id: "3ds",
        name: "Nintendo 3DS",
        versions: [
          {
            id: "3ds",
            name: "Nintendo 3DS",
            storage: "",
            disc: false,
            image: "/images/consoles/3ds.png",
          },
          {
            id: "3ds-xl",
            name: "Nintendo 3DS XL",
            storage: "",
            disc: false,
            image: "/images/consoles/3ds-xl.png",
          },
          {
            id: "2ds",
            name: "Nintendo 2DS",
            storage: "",
            disc: false,
            image: "/images/consoles/2ds.png",
          },
          {
            id: "new-3ds",
            name: "New Nintendo 3DS",
            storage: "",
            disc: false,
            image: "/images/consoles/new-3ds.png",
          },
          {
            id: "new-3ds-xl",
            name: "New Nintendo 3DS XL",
            storage: "",
            disc: false,
            image: "/images/consoles/new-3ds-xl.png",
          },
          {
            id: "new-2ds-xl",
            name: "New Nintendo 2DS XL",
            storage: "",
            disc: false,
            image: "/images/consoles/new-2ds-xl.png",
          },
        ],
      },
    ],
  },

  {
  id: "wii-u",
  name: "Nintendo Wii U",
  brand: "Nintendo",
  type: "console",
  category: "Nintendo",
  variants: [
    {
      id: "wii-u-basic",
      name: "Wii U Basic",
      versions: [
        { id: "wii-u-basic-8", name: "Wii U Basic 8 Go", storage: "8 Go", disc: true, image: "/images/consoles/wii-u-basic.png" },
      ],
    },
    {
      id: "wii-u-premium",
      name: "Wii U Premium",
      versions: [
        { id: "wii-u-premium-32", name: "Wii U Premium 32 Go", storage: "32 Go", disc: true, image: "/images/consoles/wii-u-premium.png" },
      ],
    },
  ],
},

{
  id: "gamecube",
  name: "Nintendo GameCube",
  brand: "Nintendo",
  type: "console",
  category: "Nintendo",
  variants: [
    {
      id: "gamecube-standard",
      name: "GameCube",
      versions: [
        { id: "gamecube", name: "Nintendo GameCube", storage: "", disc: true, image: "/images/consoles/gamecube.png" },
      ],
    },
  ],
},

{
  id: "nintendo-64",
  name: "Nintendo 64",
  brand: "Nintendo",
  type: "console",
  category: "Nintendo",
  variants: [
    {
      id: "n64-standard",
      name: "Nintendo 64",
      versions: [
        { id: "n64", name: "Nintendo 64", storage: "", disc: false, image: "/images/consoles/n64.png" },
      ],
    },
  ],
},

{
  id: "snes",
  name: "Super Nintendo",
  brand: "Nintendo",
  type: "console",
  category: "Nintendo",
  variants: [
    {
      id: "snes-standard",
      name: "Super Nintendo",
      versions: [
        { id: "snes", name: "Super Nintendo", storage: "", disc: false, image: "/images/consoles/snes.png" },
        { id: "snes-mini", name: "Super Nintendo Mini", storage: "", disc: false, image: "/images/consoles/snes-mini.png" },
      ],
    },
  ],
},

{
  id: "nes",
  name: "Nintendo Entertainment System",
  brand: "Nintendo",
  type: "console",
  category: "Nintendo",
  variants: [
    {
      id: "nes-standard",
      name: "NES",
      versions: [
        { id: "nes", name: "NES", storage: "", disc: false, image: "/images/consoles/nes.png" },
        { id: "nes-top-loader", name: "NES Top Loader", storage: "", disc: false, image: "/images/consoles/nes-top-loader.png" },
      ],
    },
  ],
},

{
  id: "gameboy-family",
  name: "Game Boy",
  brand: "Nintendo",
  type: "console",
  category: "Nintendo",
  variants: [
    {
      id: "gameboy-original",
      name: "Game Boy",
      versions: [
        {
          id: "gameboy-dmg",
          name: "Game Boy",
          storage: "",
          disc: false,
          image: "/images/consoles/gameboy.png",
        },
        {
          id: "gameboy-pocket",
          name: "Game Boy Pocket",
          storage: "",
          disc: false,
          image: "/images/consoles/gameboy-pocket.png",
        },
        {
          id: "gameboy-light",
          name: "Game Boy Light",
          storage: "",
          disc: false,
          image: "/images/consoles/gameboy-light.png",
        },
      ],
    },

    {
      id: "gameboy-color",
      name: "Game Boy Color",
      versions: [
        {
          id: "gameboy-color",
          name: "Game Boy Color",
          storage: "",
          disc: false,
          image: "/images/consoles/gameboy-color.png",
        },
      ],
    },

    {
      id: "gameboy-advance",
      name: "Game Boy Advance",
      versions: [
        {
          id: "gba",
          name: "Game Boy Advance",
          storage: "",
          disc: false,
          image: "/images/consoles/gba.png",
        },
        {
          id: "gba-sp",
          name: "Game Boy Advance SP",
          storage: "",
          disc: false,
          image: "/images/consoles/gba-sp.png",
        },
        {
          id: "gameboy-micro",
          name: "Game Boy Micro",
          storage: "",
          disc: false,
          image: "/images/consoles/gameboy-micro.png",
        },
      ],
    },
  ],
},
]
